import {TFetch} from "../../types";
import reducerStatuses from "../../status";
import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import {DONE, FAIL, FETCH, ARTICLES, AUTHORS, REGIONS, KINDERGARTENS, THEME_LIST, ARTICLE_LIST, AUTORS_LIST} from "../../constants";


const initialState: TFetch = {
  articles: {
    ...reducerStatuses,
    data: [] as any,
  },
  regions: {
    ...reducerStatuses,
    data: [] as any,
  },
  kindergartens: {
    ...reducerStatuses,
    data: [] as any,
  },
  themeList: {
    ...reducerStatuses,
    data: [] as any,
  },
  articleList: {
    ...reducerStatuses,
    data: null as any,
  },
  autorsList: {
    ...reducerStatuses,
    data: null as any,
  },
}


export default createReducer(initialState, builder =>
  builder
    .addCase(ARTICLES + FETCH, (state) => ({
      ...state,
      articles: {
        ...initialState.articles,
        loading: true
      }
    }))
    .addCase(ARTICLES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      articles: {
        ...initialState.articles,
        success: true,
        data: payload
      }
    }))
    .addCase(ARTICLES + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      articles: {
        ...initialState.articles,
        failed: true,
        // todo: Костыль
        data: payload
      }
    }))
    .addCase(AUTHORS + FETCH, (state) => ({
        ...state,
        authors: {
          ...initialState.authors,
          loading: true
        }
      }))
      .addCase(AUTHORS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
        ...state,
        authors: {
          ...initialState.authors,
          success: true,
          data: payload
        }
      }))
      .addCase(AUTHORS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
        ...state,
        authors: {
          ...initialState.authors,
          failed: true,
          // todo: Костыль
          data: payload
        }
      }))
      .addCase(REGIONS + FETCH, (state) => ({
        ...state,
        regions: {
          ...initialState.regions,
          loading: true
        }
      }))
      .addCase(REGIONS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
        ...state,
        regions: {
          ...initialState.regions,
          success: true,
          data: payload
        }
      }))
      .addCase(REGIONS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
        ...state,
        regions: {
          ...initialState.regions,
          failed: true,
          // todo: Костыль
          data: payload
        }
      }))
      .addCase(KINDERGARTENS + FETCH, (state) => ({
        ...state,
        kindergartens: {
          ...initialState.kindergartens,
          loading: true
        }
      }))
      .addCase(KINDERGARTENS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
        ...state,
        kindergartens: {
          ...initialState.kindergartens,
          success: true,
          data: payload
        }
      }))
      .addCase(KINDERGARTENS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
        ...state,
        kindergartens: {
          ...initialState.kindergartens,
          failed: true,
          // todo: Костыль
          data: payload
        }
      }))
      .addCase(THEME_LIST + FETCH, (state) => ({
        ...state,
        themeList: {
          ...initialState.themeList,
          loading: true,
        },
      }))
      .addCase(THEME_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
        ...state,
        themeList: {
          ...initialState.themeList,
          success: true,
          data: payload,
        },
      }))
      .addCase(THEME_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
        ...state,
        themeList: {
          ...initialState.themeList,
          failed: true,
          data: payload,
        },
      }))
      .addCase(ARTICLE_LIST + FETCH, (state) => ({
        ...state,
        articleList: {
          ...initialState.articleList,
          loading: true,
        },
      }))
      .addCase(ARTICLE_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
        ...state,
        articleList: {
          ...initialState.articleList,
          success: true,
          data: payload,
        },
      }))
      .addCase(ARTICLE_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
        ...state,
        articleList: {
          ...initialState.articleList,
          failed: true,
          data: payload,
        },
      }))
      .addCase(AUTORS_LIST + FETCH, (state) => ({
        ...state,
        autorsList: {
          ...initialState.autorsList,
          loading: true,
        },
      }))
      .addCase(AUTORS_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
        ...state,
        autorsList: {
          ...initialState.autorsList,
          success: true,
          data: payload,
        },
      }))
      .addCase(AUTORS_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
        ...state,
        autorsList: {
          ...initialState.autorsList,
          failed: true,
          data: payload,
        },
    }))
)
